/* 系统设置分组下 路由集合 */

import Layout from '@/layout'
import { getTabRedirectPath } from '@/utils/router'

// 题库
export const WeixinRouters = {
  path: '/weixin',
  component: Layout,
  meta: {
    title: '微信设置',
    icon: 'wechat-fill',
    alwaysShow: true,
  },
  redirect: '/weixin/mp_schedule',
  children: [
    {
      path: 'mp_schedule',
      name: 'weixin_mp_schedule',
      component: () => import('@/views/system/weixin/mpMessage/index'),
      meta: {
        title: '群发排期',
        icon: '',
        tabName: {
          schedule_manage: '群发排期',
          official_manage: '留言管理',
        },
      },
    },
    {
      path: 'mp_image_upload',
      name: 'mp_image_upload',
      component: () => import('@/views/system/weixin/mpImageUpload/index'),
      hidden: true,
      meta: {
        title: '图片上传',
        icon: '',
      },
    },
  ],
}

export const MaterialLib = {
  path: '/material',
  component: Layout,
  meta: {
    title: '素材库',
    icon: 'folder-open-line',
  },
  redirect: '/material/material_lib_tab_image',
  children: [
    {
      path: 'material_lib',
      name: 'material_lib_index',
      hidden: true,
      component: () => import('@/views/system/materialGroup/index.vue'),
      meta: {
        title: '',
        icon: 'image-fill',
        tabUrl: true,
        tabArr: {
          image: '图片库',
          video: '视频库',
        },
      },
    },
    {
      path: 'material_lib_tab_image',
      redirect: (to) => getTabRedirectPath(to),
      name: 'material_material_lib_tab_image',
      meta: {
        title: '图片库',
        icon: '',
      },
    },
    {
      path: 'material_lib_tab_video',
      redirect: (to) => getTabRedirectPath(to),
      name: 'material_material_lib_tab_video',
      meta: {
        title: '视频库',
        icon: '',
      },
    },
  ],
}

export const UpdateInfoRouters = {
  path: '/update_notice',
  component: Layout,
  meta: {
    title: '产品更新通知',
    icon: 'notification-2-line',
  },
  redirect: '/update_notice/index',
  children: [
    {
      path: 'index',
      name: 'update_notice_index',
      component: () => import('@/views/system/updateNotice/index'),
      meta: {
        title: '产品更新通知',
        icon: 'notification-2-line',
      },
    },
  ],
}

export const AbTestingRouters = {
  path: '/abtest_settings',
  component: Layout,
  meta: {
    title: 'AB测试配置',
    icon: 'equalizer-fill',
  },
  redirect: '/abtest_settings/index',
  children: [
    {
      path: 'index',
      name: 'abtest_settings_index',
      component: () => import('@/views/system/abtestSetting/index'),
      meta: {
        title: 'AB测试配置',
        icon: 'equalizer-fill',
      },
    },
  ],
}

export const systemSettingRouters = {
  path: '/system_setting',
  component: Layout,
  meta: {
    title: '系统配置',
    icon: 'settings-3-line',
    alwaysShow: true,
  },
  redirect: '/system_setting/mini_app_setting',
  children: [
    {
      path: 'mini_app_setting',
      name: 'system_setting_mini_app_setting',
      component: () => import('@/views/system/systemSetting/miniAppSetting/index'),
      meta: {
        title: '小程序管理',
        icon: '',
      },
    },
    {
      path: 'medal_config',
      name: 'system_setting_medal_config',
      component: () => import('@/views/medal/medalConfig/index'),
      meta: {
        title: '勋章管理',
        icon: '',
      },
    },
    {
      path: 'refactor_route_setting',
      name: 'system_setting_refactor_route_setting',
      component: () => import('@/views/system/systemSetting/refactorRouteSetting/index'),
      meta: {
        title: '新老项目路由配置',
        icon: '',
      },
    },
    {
      path: 'visualization_setting',
      name: 'system_setting_visualization_setting',
      component: () => import('@/views/system/systemSetting/visualizationSetting/index'),
      meta: {
        title: '数据可视化配置',
        icon: '',
      },
    },
    {
      path: 'script_manage',
      name: 'system_setting_script_manage',
      component: () => import('@/views/system/systemSetting/scriptManage/index'),
      meta: {
        title: '脚本管理',
        icon: '',
      },
    },
    {
      path: 'resident_script_manage',
      name: 'system_setting_resident_script_manage',
      component: () => import('@/views/system/systemSetting/residentScriptManage/index'),
      meta: {
        title: '服务管理',
        icon: '',
      },
    },
    {
      path: 'errorcode_manage',
      name: 'system_setting_errorcode_manage',
      component: () => import('@/views/system/systemSetting/errorcodeManage/index'),
      meta: {
        title: '返回码管理',
        icon: '',
      },
    },
    {
      path: 'miniproject_manage',
      name: 'system_setting_miniproject_manage',
      component: () => import('@/views/system/systemSetting/miniProject/index'),
      meta: {
        title: 'MiniProject',
        icon: '',
      },
    },
    {
      path: 'error_manage',
      name: 'system_setting_error_manage',
      component: () => import('@/views/system/systemSetting/errorManage/index'),
      meta: {
        title: '线上异常处理系统',
        icon: '',
      },
    },
    {
      path: 'qcloud_server_status',
      name: 'system_setting_qcloud_server_status',
      component: () => import('@/views/system/systemSetting/qcloudServerStatus/index'),
      meta: {
        title: '腾讯云全服务指标监控大屏',
        icon: '',
      },
    },
    {
      path: 'qcloud_rollback',
      name: 'system_setting_qcloud_rollback',
      component: () => import('@/views/system/systemSetting/qcloudRollback/index'),
      meta: {
        title: '腾讯云数据库回档',
        icon: '',
      },
    },
    {
      path: 'quick_update_time',
      name: 'system_setting_quick_update_time',
      component: () => import('@/views/system/systemSetting/quickUpdateTime/index'),
      meta: {
        title: '一键更新考试时间',
        icon: '',
      },
    },
    {
      path: 'quick_update_time_tools',
      name: 'system_setting_quick_update_exam_tools',
      component: () => import('@/views/system/systemSetting/quickUpdateTimeTools/index'),
      meta: {
        title: '一键更新考试工具',
        icon: '',
      },
    },
  ],
}

export const miniDevelopSetting = {
  path: '/mini_setting',
  component: Layout,
  meta: {
    title: '开发小工具',
    icon: 'tools-fill',
    alwaysShow: true,
  },
  // 由于小工具表格不上线, 所以线上的admin-vue3.ehafo.com 中需要隐藏
  hidden: location.origin.indexOf('.dev') == -1 ? true : false,
  redirect: '/mini_setting/mini_tools_setting',
  children: [
    {
      path: 'mini_tools_setting',
      name: 'mini_setting_mini_tools_setting',
      component: () => import('@/views/system/miniTools/index'),
      meta: {
        title: '小工具管理',
        icon: '',
      },
    },
  ],
}

export const xbotManageRouters = {
  path: '/xbot_manage',
  component: Layout,
  meta: {
    title: 'x-bot管理',
    icon: 'xing-line',
    alwaysShow: true,
  },
  redirect: '/xbot_manage/mini_app_setting',
  children: [
    {
      path: 'index',
      name: 'xbot_manage_index',
      component: () => import('@/views/system/xbotManage/index'),
      meta: {
        title: '设备管理',
        icon: '',
        tabName: {
          facility: '设备管理',
          account: '账户管理',
          unrelatedList: '未关联学员列表',
        },
      },
    },
    {
      path: 'black_list',
      name: 'xbot_black_list',
      component: () => import('@/views/system/xbotManage/blacklist'),
      meta: {
        title: '企业群黑名单用户',
        icon: '',
      },
    },
    {
      path: 'screen_word',
      name: 'xbot_screen_word',
      hidden: true,
      component: () => import('@/views/system/xbotManage/screenWord'),
      meta: {
        title: '群聊敏感词管理',
        icon: '',
      },
    },
    {
      path: 'mass_msg',
      name: 'mass_msg_index',
      hidden: true,
      component: () => import('@/views/management/marketingManagement/massMsg/tabIndex'),
      meta: {
        title: '点对点消息群发',
        icon: '',
      },
    },
    {
      path: 'xbot_setting',
      name: 'mini_setting_xbot_setting',
      component: () => import('@/views/system/xbot/index'),
      meta: {
        title: 'x-bot群发助手',
        icon: '',
      },
    },
    {
      path: 'sensitive_words',
      name: 'xbot_sensitive_words',
      hidden: true,
      component: () => import('@/views/system/xbotManage/sensitivewordsModal'),
      meta: {
        title: '敏感词管理',
        icon: '',
      },
    },
    {
      path: 'preview_user',
      name: 'xbot_preview_user',
      hidden: true,
      component: () => import('@/views/system/publicModal/previewUser'),
      meta: {
        title: '预览人员弹窗',
        icon: '',
        modalPage: true,
      },
    },
  ],
}
export const cityManageRouters = {
  path: '/city_manage',
  component: Layout,
  meta: {
    title: '城市管理',
    icon: 'equalizer-fill',
  },
  redirect: '/city_manage/index',
  children: [
    {
      path: 'index',
      name: 'city_manage_index',
      component: () => import('@/views/system/cityManage/index'),
      meta: {
        title: '城市管理',
        icon: 'equalizer-fill',
      },
    },
  ],
}
